import React, { memo } from "react";
import { Color, Cartesian3, PolylineOutlineMaterialProperty } from "cesium";
import { Entity, PolylineGraphics } from "resium";

const COLORS = { NO_ICE: Color.GREENYELLOW, PC1: Color.AQUAMARINE };

function PathLine({ feature, type }) {
  if (!feature) return null;
  const material = new PolylineOutlineMaterialProperty({
    color: COLORS[type],
  });
  const lines = feature.features.map((f, index) => {
    const coordinates = f.geometry.coordinates.flat();
    const positions = Cartesian3.fromDegreesArray(coordinates);
    return (
      <PolylineGraphics
        key={`polyline-${index}`}
        width={4}
        positions={positions}
        material={material}
      />
    );
  });
  return (
    <Entity name="passage" properties={{ model: "passage" }}>
      {lines}
    </Entity>
  );
}

export default memo(PathLine);
